'use strict';

import 'select2';
import 'parsleyjs';
import 'parsleyjs/src/extra/validator/comparison.js';
import 'parsleyjs/src/extra/validator/date.js';
import 'parsleyjs/src/extra/validator/notequalto.js';
import 'parsleyjs/src/extra/validator/words.js';
import {Tooltip, Popover} from 'bootstrap';
import './dropify.js';

window.$ = window.jQuery = require('jquery');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.moment = require('moment');

// non es6 module supported jQuery plugins
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import 'bootstrap-daterangepicker/daterangepicker.js';

/* Bootstrap tooltips */
window.loadTooltip = function () {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
    });
}

window.loadTooltip();

/* Bootstrap popover */
window.loadPopover = function () {
    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl);
    });
}

window.loadPopover();

/* ParsleyJS custom validations */
window.Parsley.on('field:success', function (fieldInstance) {
    const errLists = this.$element.parents('form').find('.parsley-container');

    errLists.each(function () {
        if ($(this).children().length == 0) {
            $(this).remove();
        }
    });
});

window.Parsley.addValidator('atleastOne', {
    validateString: function (value, requirement, parsleyInstance) {
        let filledFields = 0;
       
        $(requirement).each(function () {
          
            if ($(this).attr('type') !== 'undefined' && ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio')) {
                if ($(this).is(':checked')) {
                    filledFields++;
                }
            } else if ($(this).attr('type') == 'file') {
                if ($(this).siblings().last().children().first().children().length > 0) {
                    filledFields++;
                }
                    
            } else if ($(this).val().length > 0) {
                filledFields++;
            }
        });
        return filledFields > 0;
    },
    validateMultiple: function (value, requirement, parsleyInstance) {
        let filledFields = 0;
        $(requirement).each(function () {
            if ($(this).attr('type') !== 'undefined' && ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') ) {
                if ($(this).is(':checked')) {
                    filledFields++;
                }
            } else if ($(this).attr('type') == 'file') {
                if ($(this).siblings().last().children().first().children().length > 0) {
                    filledFields++;
                }
                    
            } else if ($(this).val().length > 0) {
                filledFields++;
            }
        });

        return filledFields > 0;
    },
    messages: {
        en: 'Atleast one field must be filled'
    }
});

window.Parsley.addValidator('minFileSize', {
    validateString: function(_value, minSize, parsleyInstance) {
    if (!window.FormData) {
        alert('You are making all developpers in the world cringe. Upgrade your browser!');
        return true;
    }
    var files = parsleyInstance.$element[0].files;
    return files.length != 1  || files[0].size >= minSize * 1024;
    },
    requirementType: 'integer',
    messages: {
    en: 'This file should not be less than %s Kb'
    }
});

window.Parsley.addValidator('maxFileSize', {
    validateString: function(_value, maxSize, parsleyInstance) {
    if (!window.FormData) {
        alert('You are making all developpers in the world cringe. Upgrade your browser!');
        return true;
    }
    var files = parsleyInstance.$element[0].files;
    return files.length != 1  || files[0].size <= maxSize * 1024;
    },
    requirementType: 'integer',
    messages: {
    en: 'This file should not be larger than %s Kb'
    }
});

window.Parsley.addValidator('fileExtension', {
    validateString: function(_value, requirement, parsleyInstance) {
        if (!window.FormData) {
            alert('You are making all developpers in the world cringe. Upgrade your browser!');
            return true;
        }
        var fileExtension = _value.split('.').pop();
        return fileExtension === requirement;
    },
    requirementType: 'string',
    messages: {
    en: 'Please upload valid %s file format.'
    }
});

/*
window.Parsley.addValidator('minImageDimension', {
    requirementType: 'string',
    validateString: function (value, requirement, parsleyInstance) {
        /*
        let file = parsleyInstance.$element[0].files[0];
        let [width, height] = requirement.split('x');
        let image = new Image();
        let deferred = $.Deferred();

        image.src = window.URL.createObjectURL(file);
        image.onload = function() {
            if (image.width >= width && image.height >= height) {
                deferred.resolve();
            } else {
                deferred.reject();
            }
        };

        return deferred.promise();
        
    },
    messages: {
        en: 'Image dimensions have to be at least %spx'
    }
});
*/

window.setSearchByOption = function () {
	$(".search-filter a.dropdown-item").removeClass('active');
	
	if (window.localStorage.getItem('searchBy') != null) {
		$(".search-filter a.dropdown-item[data-param='"+window.localStorage.getItem('searchBy')+"']").addClass('active');
	} else {
		$(".search-filter a.dropdown-item[data-param='contains']").addClass('active');
	}
}